webpackJsonp([114276838955818,60335399758886],{

/***/ 118:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"HCV Handbook","description":"Hepatitis C","manifesto":["This is a mini site dedicated to one topic only, which is Hepatitis C.","All information on this site is collected from Internet and we will credit all the sources as acknowledgement.","We build this site to provide the convenience of a one-stop knowledge base on Hepatitis C for end-user/consumer group."]}}},"layoutContext":{}}

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(218);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(118);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(111);
	var isArguments = __webpack_require__(110);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 110:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 111:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(142);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(109);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(138);
	
	var _HelmetConstants = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 52:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(3);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(113));
	var shallowEqual = _interopDefault(__webpack_require__(143));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 143:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 54:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOTYuMTYgMTgzLjQ5Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDojZmZmO308L3N0eWxlPjwvZGVmcz48dGl0bGU+YmlvaGF6YXJkPC90aXRsZT48cGF0aCBjbGFzcz0iYSIgZD0iTTE2NS4zOCw2OC42MWE2MS40Nyw2MS40NywwLDAsMC02LjE2LTMuMUE2MS40OSw2MS40OSwwLDAsMCwxMTksLjIzYTMuODgsMy44OCwwLDAsMC0zLjA5LDcuMSwzOS4xOSwzOS4xOSwwLDAsMSwxOC44MSw0OUE1Ny40MSw1Ny40MSwwLDAsMCw2MS4zMyw1NiwzOS4xOSwzOS4xOSwwLDAsMSw4MC4yNyw3LjMzLDMuODgsMy44OCwwLDAsMCw3Ny4xOC4yMyw2MS41Miw2MS41MiwwLDAsMCwzNyw2NS40OSw2MS41LDYxLjUsMCwwLDAsMSwxMzIuNzZhMy44OSwzLjg5LDAsMCwwLDcuNzEtLjY4LDMuNzQsMy43NCwwLDAsMCwwLS41N0EzOS4xNywzOS4xNywwLDAsMSw0MS4wOCw5MS4xOWE1Ny40OCw1Ny40OCwwLDAsMCwzNy4yNSw2My4zNSwzOS4yMSwzOS4yMSwwLDAsMS01MS44NSw4LjIzQTMuODgsMy44OCwwLDAsMCwyMS44OCwxNjlhNjEuNTYsNjEuNTYsMCwwLDAsNzAuNDcsNi4yNCw2Mi41NSw2Mi41NSwwLDAsMCw1Ljc0LTMuNzYsNjEuNTQsNjEuNTQsMCwwLDAsNzYuMi0yLjQ4LDMuODgsMy44OCwwLDAsMC00LjYxLTYuMjEsMzkuMTgsMzkuMTgsMCwwLDEtNTEuOTUtOC4zNSw1Ny41LDU3LjUsMCwwLDAsMzYuOTEtNjMuMzEsMzkuMTgsMzkuMTgsMCwwLDEsMzIuODgsNDAuNzYsMy44OCwzLjg4LDAsMCwwLDcuNjkuODhBNjEuNzQsNjEuNzQsMCwwLDAsMTY1LjM4LDY4LjYxWm0tNDEuODUsMy42YTM5LjI2LDM5LjI2LDAsMCwxLTUxLjEtLjIsMzguMTIsMzguMTIsMCwwLDEsNTEuMS4yWk01OS43MiwxMDAuNDNhMzguMzQsMzguMzQsMCwwLDEsLjc5LTcuNzUsMzkuMTYsMzkuMTYsMCwwLDEsMTcuMTIsMTEuNTgsMzguOTQsMzguOTQsMCwwLDEsNy4wNywxMi4wNiwzOSwzOSwwLDAsMSwxLjc3LDIwLjUzQTM4LjE1LDM4LjE1LDAsMCwxLDU5LjcyLDEwMC40M1ptNDkuOTQsMzYuMjhhMzksMzksMCwwLDEsMS43OS0yMC4zOCwzOC45LDM4LjksMCwwLDEsNy4wOC0xMi4wNywzOS4xMSwzOS4xMSwwLDAsMSwxNi43Mi0xMS40MywzOC4xOSwzOC4xOSwwLDAsMS0yNS41OSw0My44OFoiLz48L3N2Zz4="

/***/ }),

/***/ 55:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjAuODcgMTYwLjY0Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDojZmZmO308L3N0eWxlPjwvZGVmcz48dGl0bGU+Y2hlY2tib2FyZDwvdGl0bGU+PHBhdGggY2xhc3M9ImEiIGQ9Ik0xMTguOTMsMEgxLjk0QTEuOTQsMS45NCwwLDAsMCwwLDEuOTRWMTU1LjczYTQuOSw0LjksMCwwLDAsNC45LDQuOTFIMTE2YTQuOSw0LjksMCwwLDAsNC45LTQuOTFWMS45NEExLjk0LDEuOTQsMCwwLDAsMTE4LjkzLDBaTTE2LjM3LDM3LjE0di0xM2gxMS41VjEyLjY0aDEzdjExLjVoMTEuNXYxM0g0MC44N3YxMS41aC0xM1YzNy4xNFpNNzksMTM2LjUxSDE3LjcyVjEyNS42NEg3OVptMC0zMS45SDE3Ljcydi0xMEg3OVptMC0zMi4yMkgxNy43MlY2Mi42NEg3OVptMjEuMzEsNTMuNzFWMTM3SDg5LjIxVjEyNi4xWm0wLTMyVjEwNUg4OS4yMVY5NC4wOVptMC0yMS40NUg4OS44N3YtMTBoMTAuNDZaIi8+PC9zdmc+"

/***/ }),

/***/ 56:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMTMuMjUgMTU2LjMxIj48ZGVmcz48c3R5bGU+LmF7ZmlsbDojZmZmO308L3N0eWxlPjwvZGVmcz48dGl0bGU+dHJlYXRtZW50PC90aXRsZT48cGF0aCBjbGFzcz0iYSIgZD0iTTEwMCwzLjYyYTI2LjYsMjYuNiwwLDAsMC0zNi4zNyw5LjZsLTMwLDUxLjU2aDBsLTMwLDUxLjU0YTI2LjYsMjYuNiwwLDEsMCw0NiwyNi43N2wzMC01MS41NS0zLjk0LTIuMjlMMzcuNTgsNjcuMDdsLS4yMi0uMTMuMjIuMTMsMzguMSwyMi4xOSwzLjk0LDIuMjksMzAtNTEuNTVBMjYuNjEsMjYuNjEsMCwwLDAsMTAwLDMuNjJabTYuODIsMzQuNzZMNzYuOTQsODkuOCwzNi41NCw2Ni4yOGwyOS45LTUxLjQ0YTIzLjM4LDIzLjM4LDAsMSwxLDQwLjQsMjMuNTRaIi8+PC9zdmc+"

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMzIuMDUgMTYxLjY5Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDojZmZmO308L3N0eWxlPjwvZGVmcz48dGl0bGU+Z2VuZTwvdGl0bGU+PHBhdGggY2xhc3M9ImEiIGQ9Ik01My43NCwxNjEuMDljLTEuNjgtLjkxLTIuNDctMy0yLjQ1LTUuNDJhMTYuNCwxNi40LDAsMCwxLDIuMzItNy44NHMxLjgxLTIuOTQsNC4zMy03LjcxYTExNy4wOCwxMTcuMDgsMCwwLDAsOC0xOC43OGMyLjM2LTcuMzMsMy42OS0xNS40LDMtMjIuMjNhMzEuMDksMzEuMDksMCwwLDAtNS40My0xNS4zNSwzMC4xNiwzMC4xNiwwLDAsMC0yLjEtMi42NUw2MCw3OS41QTI3LjMzLDI3LjMzLDAsMCwxLDU4LDc3YTMwLjU5LDMwLjU5LDAsMCwxLTUuMjMtMTIuODFjLTEuNjItOS41MS4yLTE5LjIsMi41OS0yNy41OWExNDUuODcsMTQ1Ljg3LDAsMCwxLDgtMjFjMi40Ni01LjI0LDQuMjEtOC40Myw0LjItOC40NEM3MC43MywxLjQ2LDc2LjI3LTEuNDIsNzkuNDYuNjlzMy4xNSw3Ljg0LjI1LDEzLjE3YTE1MC4xMSwxNTAuMTEsMCwwLDAtMTIsMjRDNjUuMjEsNDQuNTIsNjMuMjcsNTIsNjMuMjcsNTguNHMyLjA4LDExLjQ3LDQuNDcsMTRsMS4zOCwxLjUxYy41NC41OCwxLjA3LDEuMjMsMS42MywxLjlBNDMuODEsNDMuODEsMCwwLDEsNzQsODAuNDRhNDIuOTMsNDIuOTMsMCwwLDEsNS4xMSwxMi40NWMyLjMyLDkuNDUsMS40MywyMC4xNS0uODEsMjkuMzlhMTI4LjEzLDEyOC4xMywwLDAsMS04LjE5LDIzLjE3Yy0yLjY1LDUuNzctNC41Nyw5LjI2LTQuNTUsOS4yN2ExNS40NywxNS40NywwLDAsMS02LDZBNi4xOCw2LjE4LDAsMCwxLDUzLjc0LDE2MS4wOVoiLz48cmVjdCBjbGFzcz0iYSIgeD0iNjUuODEiIHk9IjQyLjAzIiB3aWR0aD0iNC40MiIgaGVpZ2h0PSIyMC42OCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEwLjgzIDg2LjMxKSByb3RhdGUoLTYwLjg4KSIvPjxyZWN0IGNsYXNzPSJhIiB4PSI4NS4yOSIgeT0iNTQuNjUiIHdpZHRoPSI0LjQyIiBoZWlnaHQ9IjE3LjEzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTAuMzEgMTA4LjkpIHJvdGF0ZSgtNjAuODgpIi8+PHJlY3QgY2xhc3M9ImEiIHg9IjczLjUiIHk9IjI3LjgyIiB3aWR0aD0iNC40MiIgaGVpZ2h0PSIxOS45NCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNS44NyA4NS41Nykgcm90YXRlKC02MC45KSIvPjxyZWN0IGNsYXNzPSJhIiB4PSI5My4xNiIgeT0iNDAuMDEiIHdpZHRoPSI0LjQyIiBoZWlnaHQ9IjE3LjQ2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2LjQgMTA4LjM3KSByb3RhdGUoLTYwLjkpIi8+PHJlY3QgY2xhc3M9ImEiIHg9IjgxLjEyIiB5PSIxNC4xMSIgd2lkdGg9IjQuNDIiIGhlaWdodD0iMTkuODgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxLjc3IDg1LjE1KSByb3RhdGUoLTYwLjg4KSIvPjxyZWN0IGNsYXNzPSJhIiB4PSIxMDIuNjEiIHk9IjI1LjYxIiB3aWR0aD0iNC40MiIgaGVpZ2h0PSIyMC44MiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjIuMzUgMTEwLjA3KSByb3RhdGUoLTYwLjg4KSIvPjxyZWN0IGNsYXNzPSJhIiB4PSIyNy44NiIgeT0iMTExLjUyIiB3aWR0aD0iNC40MiIgaGVpZ2h0PSIyMy4yOSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTkyLjE2IDg5LjUxKSByb3RhdGUoLTYwLjg4KSIvPjxyZWN0IGNsYXNzPSJhIiB4PSI1MS44NSIgeT0iMTI0LjQ4IiB3aWR0aD0iNC40MiIgaGVpZ2h0PSIyMy4yOSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTkxLjE3IDExNy4xMSkgcm90YXRlKC02MC44OCkiLz48cmVjdCBjbGFzcz0iYSIgeD0iMzYuMjUiIHk9Ijk2LjkxIiB3aWR0aD0iNC40MiIgaGVpZ2h0PSIyNC4xMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTc1LjQ2IDg5LjU1KSByb3RhdGUoLTYwLjg4KSIvPjxyZWN0IGNsYXNzPSJhIiB4PSI2MC4wMyIgeT0iMTEwLjMxIiB3aWR0aD0iNC40MiIgaGVpZ2h0PSIyNC4xMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTc0Ljk2IDExNy4yMSkgcm90YXRlKC02MC44OSkiLz48cmVjdCBjbGFzcz0iYSIgeD0iNDMuMzkiIHk9IjgzLjQ4IiB3aWR0aD0iNC40MiIgaGVpZ2h0PSIyMi45NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU5LjU1IDg4LjYpIHJvdGF0ZSgtNjAuODkpIi8+PHJlY3QgY2xhc3M9ImEiIHg9IjY2LjQ3IiB5PSI5Ni4wNiIgd2lkdGg9IjQuNDIiIGhlaWdodD0iMjIuOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01OC42OSAxMTUuMjMpIHJvdGF0ZSgtNjAuODkpIi8+PHBhdGggY2xhc3M9ImEiIGQ9Ik00LjYxLDEzNS4yM2E5LDksMCwwLDEtNC4zNi02LDEyLjYzLDEyLjYzLDAsMCwxLDEuMzktOC42NHMxLjc4LTMuMjYsNC45NS04LjMxQTEzNSwxMzUsMCwwLDEsMjAuNSw5My43OWM2LjA2LTYuNjksMTMuOC0xMy4yOSwyMi4zOC0xNy4zMmE0OS4yOCw0OS4yOCwwLDAsMSwxMi42OS00QTQ2LDQ2LDAsMCwxLDY2LDcxLjg3YzEuNDcuMDgsMy4xLjI2LDQuODcuNTRsMi40MS40M2ExMi41MywxMi41MywwLDAsMCwxLjQ5LjE3LDE1Ljc1LDE1Ljc1LDAsMCwwLDcuMTQtMS40NWM1LjQxLTIuMjgsMTEuMzctNy42MSwxNi4xOS0xMy4zM0ExNDUuMywxNDUuMywwLDAsMCwxMTQsMzQuNDNjMy01LjE5LDguNzctNy42NiwxMy40Ni01LjUxczYuMTEsOSwyLjgxLDE0Ljc0YTE3Ny4yOSwxNzcuMjksMCwwLDEtMTgsMjMuNEMxMDYuNzYsNzMsMTAwLjE0LDc4Ljk1LDkyLjU4LDgyLjkzQTM3LjcsMzcuNywwLDAsMSw4MSw4N2EyOS4yNSwyOS4yNSwwLDAsMS0xMC4xOC0uMWwtMi0uMzdjLS41OS0uMTItMS4yMy0uMTctMS44OC0uMjZhMzEuNjEsMzEuNjEsMCwwLDAtNC4yNC0uMTFBMjkuODksMjkuODksMCwwLDAsNTMsODguMzJDNDYuMjYsOTEsMzkuNjEsOTYuNjQsMzQuMzgsMTAyLjk0YTEwOC43MiwxMDguNzIsMCwwLDAtMTIsMTguMTNjLTIuNzIsNS4wOC00LjIyLDguNDYtNC4yMyw4LjQ1YTEzLDEzLDAsMCwxLTYuMDYsNS43MkE4LjIsOC4yLDAsMCwxLDQuNjEsMTM1LjIzWiIvPjwvc3ZnPg=="

/***/ }),

/***/ 144:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOTYuMjMgMTkyLjMxIj48ZGVmcz48c3R5bGU+LmF7ZmlsbDojZmZmO308L3N0eWxlPjwvZGVmcz48dGl0bGU+aG9tZTwvdGl0bGU+PHBhdGggY2xhc3M9ImEiIGQ9Ik0zMi4wNSw5NnY5Ni4yNkgxNjQuMThWOTZMOTguMTIsMzBabTEwMSwxOXYyNi4wNmgtMjJ2MjJIODUuMDl2LTIyaC0yMlYxMTVoMjJ2LTIyaDI2LjA2djIyWiIvPjxwb2x5Z29uIGNsYXNzPSJhIiBwb2ludHM9Ijk4LjEyIDAgMCA5OC4xMiAxMi4zNiAxMTAuNDggOTguMTIgMjQuNzIgMTgzLjg3IDExMC40OCAxOTYuMjMgOTguMTIgOTguMTIgMCIvPjwvc3ZnPg=="

/***/ }),

/***/ 26:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOTIuNjQgMTY5LjUyIj48ZGVmcz48c3R5bGU+LmF7ZmlsbDojZmVmZWZlO2ZpbGwtcnVsZTpldmVub2RkO308L3N0eWxlPjwvZGVmcz48dGl0bGU+bGl2ZXI8L3RpdGxlPjxwYXRoIGNsYXNzPSJhIiBkPSJNMTI1Ljg1LDc1LjY4QTE0NC44LDE0NC44LDAsMCwwLDEzMS4yOCw5OWMuMjYsMS41NS43OCwzLjExLDMuMSwyLjA3LDE3LjM0LTcuMjQsMjguMjEtMTguNjIsMzAuODEtMzgsMy44OC0zMS4zMSwyNC41OC0zMi44NiwyNy4xNy00OC42NC41Mi0yLjU5LjUyLTUuMTgtMS44MS03LTIxLjIyLTE1Ljc5LTQ3LjM2LTIuODUtNjguMDcsNy43Ny0xLjU1LDEtMS41NSwyLjA3LTEuMjksMy42MiwzLjYzLDE4LjYzLDEsMzcuNTIsNC42Niw1Ni45M1pNMTAzLjU5LDY1LjA3QTg4LjI1LDg4LjI1LDAsMCwxLDg5LjEsMzIuNDZjLS4yNi0xLjgxLS4yNi00LjQtMS4yOS01LjY5LTEuNTYtMS41NS00LjE1LDAtNi4yMSwwQzQzLjU0LDIzLjkyLDEuODgsNTMuOTQuMDcsOTQuODNjLS43OCwxNy42LDUuMTcsNDcuMzYsMTMuNzEsNjMuMTQsMi4wNywzLjg5LDQuNjYsNy41MSw4LjI4LDkuODNzNS4xNywyLjM0LDguNTQtLjI2YTI5LjM1LDI5LjM1LDAsMCwwLDYuMjEtNi40NkM0OC43MiwxNDQsNzUuODksMTQyLjcsOTQsMTMxLjMyYzguOC01LjQ0LDE2LjgyLTExLjkxLDIzLjMtMjEuMjMsMy4zNi00LjkxLDQuOTItMy4zNiwzLjM2LTkuMzItMy4xLTExLjktMTAuMDktMjUuNjEtMTcuMDktMzUuN1ptNC4xNS0xYzcuNzYsMTEuNjQsMTMuNzEsMjQuMzIsMTUuMjcsMzguNTYuNTIsNC4xNCwyLjMzLDYuNDYsNC45Miw4Ljc5LDIuMzMsMS44MiwxMS4zOSw4LjI4LDEzLjIsMy4xMWEyLjA3LDIuMDcsMCwwLDAtMS41NS0yLjg0Yy01LjE4LTEuODItOC01LjE4LTEwLjA5LTEwLjYyYTE0MS42MSwxNDEuNjEsMCwwLDEtMTAuMDktNTAuNzJjMC03LS4yNi0xNC4yMy41Mi0yMS43NCwwLTEuMjktLjI2LTMuMS0uMjYtNC42Ni0uNTItOCwxLjI5LTcuNS02Ljc0LTMuODgtLjc3LjI2LTEuMjkuNzctMi4wNy41Mi0uNzctLjc4LDAtMS41NSwwLTIuMzMsMS0yLjU5LDEuODEtNS40NCwyLjU5LTgsLjI2LS43OC43Ny0xLjgxLS4yNi0yLjMzLTIuNTgtMS41NS04LC4yNi05LjA2LDMuMS0xLjI5LDMuNjItMy4zNiw3LTUuMTcsMTAuNjFhNi42LDYuNiwwLDAsMS01LjcsMy44OGMtMy4zNi41Mi0zLjM2LDEtMi4zMyw0LjE0QTEzNi43MSwxMzYuNzEsMCwwLDAsMTA3LjczLDY0WiIvPjwvc3ZnPg=="

/***/ }),

/***/ 58:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOTEuMTUgMTQ0LjE5Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDojZmZmO308L3N0eWxlPjwvZGVmcz48dGl0bGU+bWVkaWNhbC1jYXNlPC90aXRsZT48cGF0aCBjbGFzcz0iYSIgZD0iTTExOC4zNywwSDc0LjY5YTExLjM5LDExLjM5LDAsMCwwLTExLjQsMTEuNFYzMy41NWExMS40LDExLjQsMCwwLDAsMTEuNCwxMS4zOWg0My42OGExMS4zOSwxMS4zOSwwLDAsMCwxMS4zOS0xMS4zOVYxMS40QTExLjM4LDExLjM4LDAsMCwwLDExOC4zNywwWm0zLjc5LDMzLjU1YTMuNzksMy43OSwwLDAsMS0zLjc5LDMuNzlINzQuNjlhMy43OSwzLjc5LDAsMCwxLTMuNzktMy43OVYxMS40YTMuNzksMy43OSwwLDAsMSwzLjc5LTMuOGg0My42OGEzLjc5LDMuNzksMCwwLDEsMy43OSwzLjhaIi8+PHBhdGggY2xhc3M9ImEiIGQ9Ik0xNzkuNzYsMjMuMjhIMTEuMzlBMTEuMzksMTEuMzksMCwwLDAsMCwzNC42OHY5OC4xMWExMS4zOSwxMS4zOSwwLDAsMCwxMS4zOSwxMS40SDE3OS43NmExMS4zOSwxMS4zOSwwLDAsMCwxMS4zOS0xMS40VjM0LjY4QTExLjM5LDExLjM5LDAsMCwwLDE3OS43NiwyMy4yOFptLTU2LDY1LjA2SDEwMy45MnYxOS44Mkg4OS4xM1Y4OC4zNEg2OS4zMVY3My41NUg4OS4xM1Y1My43M2gxNC43OVY3My41NWgxOS44MloiLz48L3N2Zz4="

/***/ }),

/***/ 59:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 60:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3Ny42IDE4Ni44NiI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6I2ZmZjt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmNvbXBsaWNhdGlvbnM8L3RpdGxlPjxwYXRoIGNsYXNzPSJhIiBkPSJNNDQuNzIsMzcsMzkuODIsNDJsLTQuNzYtNWgwYy0yLjUxLjYtOCwzLjU3LTguMzgsMy44MWwtLjEyLjA3TDM2LjksNjcuMzJsMTAuMy0yOS41MUEyMywyMywwLDAsMCw0NC43MiwzN1oiLz48cGF0aCBjbGFzcz0iYSIgZD0iTTM2Ljc5LDcyLjQ3djBsLTEyLTMwLjYxLS40OC4zMUwxOS41OSw3Mi4zOUgxNy44MWw0LjM1LTI4LjczQzIwLjMxLDQ1LDYuMiw1NS4yOC41OSw3My41N2MtLjgzLDIuNjctMSw2LjQ2Ljc4LDguNjVTNSw4NS43LDE4LjczLDg2LjM3YzAsMCwxNi44OC0uMSwxNi44OC0uMWE3LDcsMCwwLDAsMS4xOS0xMy44MVoiLz48cGF0aCBjbGFzcz0iYSIgZD0iTTQ1LjYxLDQ4LjM5LDM3Ljc3LDcwLjgzYTguNzgsOC43OCwwLDAsMSw0LDIuMloiLz48cGF0aCBjbGFzcz0iYSIgZD0iTTQ5LjE0LDM4LjY2LDQzLjQ1LDc0Ljc3YTExLjM0LDExLjM0LDAsMCwxLDEuMTMsNSw4LjkzLDguOTMsMCwwLDEtOSw4LjMxaC0xNnY5LjUzYzAsNS44MSwxLjQ4LDcsMS40OCw3djc0LjA4aC4xYTksOSwwLDAsMCwxOC0uODR2LTNoMHYtMy41N2gwVjE2OWgwdi0zLjU3aDBWMTE1Yy4zNiwwLC43MiwwLDEuMDgsMGguMjF2NjIuODJhOSw5LDAsMSwwLDE4LjA4LDBWMTA1czEuNC0xLjY2LDEuNC03LjRWNjkuMjNjLjU0LjU3LDQuNDIsMTcuMzUsMy40NywyNy4xNmE2LjkzLDYuOTMsMCwwLDAsNi4yLDcuNTgsNiw2LDAsMCwwLC43LDAsNi45Myw2LjkzLDAsMCwwLDYuODgtNi4yM0M3OS44OSw3MS4xMiw2OC4wNiw0Ni4xMiw0OS4xNCwzOC42NloiLz48Y2lyY2xlIGNsYXNzPSJhIiBjeD0iMzkuNTgiIGN5PSIxNy43OCIgcj0iMTcuNzgiLz48L3N2Zz4="

/***/ }),

/***/ 61:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNzIuMzUgMTkxLjAyIj48ZGVmcz48c3R5bGU+LmF7ZmlsbDojZmZmO308L3N0eWxlPjwvZGVmcz48dGl0bGU+dW1icmVsbGE8L3RpdGxlPjxwYXRoIGNsYXNzPSJhIiBkPSJNODYuMTcsMjMuNWgwYTg2LjE3LDg2LjE3LDAsMCwxLDg2LjE3LDg2LjE3YzAsMi4yNi0uMTEsNC40OS0uMjksNi43MWEyOC40NCwyOC40NCwwLDAsMC01Ni4zOCwwaC0uNTlBMjguNDUsMjguNDUsMCwwLDAsODYuOSw5MS43MmMtLjI1LDAtLjQ4LDAtLjczLDBzLS40OCwwLS43MywwYTI4LjQ1LDI4LjQ1LDAsMCwwLTI4LjE5LDI0LjY2aC0uNTlhMjguNDQsMjguNDQsMCwwLDAtNTYuMzgsMGMtLjE3LTIuMjItLjI5LTQuNDUtLjI5LTYuNzFBODYuMTcsODYuMTcsMCwwLDEsODYuMTcsMjMuNVoiLz48cGF0aCBjbGFzcz0iYSIgZD0iTTY5Ljk0LDE5MWEyMC45LDIwLjksMCwwLDAsMjAuODgtMjAuODhWMTA2LjczYTQuNjQsNC42NCwwLDEsMC05LjI4LDB2NjMuNDJhMTEuNiwxMS42LDAsMCwxLTIzLjE5LDBWMTY3YTQuNjQsNC42NCwwLDAsMC05LjI4LDB2My4xQTIwLjksMjAuOSwwLDAsMCw2OS45NCwxOTFaIi8+PHBhdGggY2xhc3M9ImEiIGQ9Ik04Ni4xOCwyMS42NUE0LjY0LDQuNjQsMCwwLDAsOTAuODIsMTdWNC42NGE0LjY0LDQuNjQsMCwxLDAtOS4yOCwwVjE3QTQuNjQsNC42NCwwLDAsMCw4Ni4xOCwyMS42NVoiLz48L3N2Zz4="

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _liver = __webpack_require__(26);
	
	var _liver2 = _interopRequireDefault(_liver);
	
	var _biohazard = __webpack_require__(54);
	
	var _biohazard2 = _interopRequireDefault(_biohazard);
	
	var _gene = __webpack_require__(57);
	
	var _gene2 = _interopRequireDefault(_gene);
	
	var _patientVomitting = __webpack_require__(59);
	
	var _patientVomitting2 = _interopRequireDefault(_patientVomitting);
	
	var _gel = __webpack_require__(56);
	
	var _gel2 = _interopRequireDefault(_gel);
	
	var _medicalCase = __webpack_require__(58);
	
	var _medicalCase2 = _interopRequireDefault(_medicalCase);
	
	var _checkboard = __webpack_require__(55);
	
	var _checkboard2 = _interopRequireDefault(_checkboard);
	
	var _patient = __webpack_require__(60);
	
	var _patient2 = _interopRequireDefault(_patient);
	
	var _umbrella = __webpack_require__(61);
	
	var _umbrella2 = _interopRequireDefault(_umbrella);
	
	var _home = __webpack_require__(144);
	
	var _home2 = _interopRequireDefault(_home);
	
	__webpack_require__(119);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Categories = function Categories(_ref) {
	  var page = _ref.page;
	
	  return _react2.default.createElement(
	    'div',
	    { 'data-page': page, className: 'categories' },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { className: 'btn', to: '/category/risk/' },
	      _react2.default.createElement('img', { className: 'btn-img', src: _biohazard2.default, alt: '' }),
	      _react2.default.createElement(
	        'span',
	        { className: 'btn-text' },
	        'Who is at risk'
	      )
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { className: 'btn', to: '/category/symptoms/' },
	      _react2.default.createElement('img', { className: 'btn-img', src: _patientVomitting2.default, alt: '' }),
	      _react2.default.createElement(
	        'span',
	        { className: 'btn-text' },
	        'Symptoms'
	      )
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { className: 'btn', to: '/category/diagnosis/' },
	      _react2.default.createElement('img', { className: 'btn-img', src: _gene2.default, alt: '' }),
	      _react2.default.createElement(
	        'span',
	        { className: 'btn-text' },
	        'Diagnosis'
	      )
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { className: 'btn', to: '/category/treatment/' },
	      _react2.default.createElement('img', { className: 'btn-img', src: _gel2.default, alt: '' }),
	      _react2.default.createElement(
	        'span',
	        { className: 'btn-text' },
	        'Treatment'
	      )
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { className: 'btn', to: '/category/complications/' },
	      _react2.default.createElement('img', { className: 'btn-img', src: _checkboard2.default, alt: '' }),
	      _react2.default.createElement(
	        'span',
	        { className: 'btn-text' },
	        'Complications'
	      )
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { className: 'btn', to: '/category/living-with/' },
	      _react2.default.createElement('img', { className: 'btn-img', src: _medicalCase2.default, alt: '' }),
	      _react2.default.createElement(
	        'span',
	        { className: 'btn-text' },
	        'Living with HCV'
	      )
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { className: 'btn', to: '/category/prevention/' },
	      _react2.default.createElement('img', { className: 'btn-img', src: _umbrella2.default, alt: '' }),
	      _react2.default.createElement(
	        'span',
	        { className: 'btn-text' },
	        'Prevention'
	      )
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { className: 'btn', to: '/' },
	      _react2.default.createElement('img', { className: 'btn-img', src: _home2.default, alt: '' }),
	      _react2.default.createElement(
	        'span',
	        { className: 'btn-text' },
	        'Home'
	      )
	    )
	  );
	};
	
	exports.default = Categories;
	module.exports = exports['default'];

/***/ }),

/***/ 119:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(457);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var date = new Date();
	var CurrentYear = date.getFullYear();
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'footer' },
	    _react2.default.createElement(
	      'div',
	      { className: 'footer-container' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/acknowledge' },
	          'Acknowledgement'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'HCV.APP, ',
	          CurrentYear
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'license',
	            rel: 'license',
	            href: 'http://creativecommons.org/licenses/by-nc-sa/4.0/'
	          },
	          _react2.default.createElement('img', {
	            alt: 'Creative Commons License',
	            src: 'https://i.creativecommons.org/l/by-nc-sa/4.0/80x15.png'
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 457:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(458);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(_ref) {
	  var page = _ref.page,
	      siteInfo = _ref.siteInfo;
	
	  var gradients = function gradients() {
	    return _react2.default.createElement(
	      'defs',
	      null,
	      _react2.default.createElement(
	        'linearGradient',
	        {
	          id: 't1',
	          x1: '129.18',
	          y1: '381.7',
	          x2: '293.83',
	          y2: '381.7',
	          gradientTransform: 'matrix(0.91, 0.42, -0.42, 0.91, 54.4, -340.59)',
	          gradientUnits: 'userSpaceOnUse'
	        },
	        _react2.default.createElement('stop', { offset: '0%', stopColor: '#9cdcff' }),
	        _react2.default.createElement('stop', { offset: '13%', stopColor: '#96d3f8' }),
	        _react2.default.createElement('stop', { offset: '35%', stopColor: '#84bbe6' }),
	        _react2.default.createElement('stop', { offset: '62%', stopColor: '#6894c9' }),
	        _react2.default.createElement('stop', { offset: '94%', stopColor: '#425fa1' }),
	        _react2.default.createElement('stop', { offset: '100%', stopColor: '#395398' })
	      ),
	      _react2.default.createElement(
	        'linearGradient',
	        {
	          id: 't2',
	          x1: '42.76',
	          y1: '300.2',
	          x2: '232.36',
	          y2: '300.2',
	          gradientTransform: 'translate(-55.94 -194.25) rotate(-2.45)',
	          gradientUnits: 'userSpaceOnUse'
	        },
	        _react2.default.createElement('stop', { offset: '0%', stopColor: '#b620b4' }),
	        _react2.default.createElement('stop', { offset: '23%', stopColor: '#ad23b5' }),
	        _react2.default.createElement('stop', { offset: '60%', stopColor: '#952bb8' }),
	        _react2.default.createElement('stop', { offset: '100%', stopColor: '#7437bc' })
	      ),
	      _react2.default.createElement(
	        'radialGradient',
	        {
	          id: 't3',
	          cx: '0.65',
	          cy: '196.26',
	          r: '256.13',
	          gradientUnits: 'userSpaceOnUse'
	        },
	        _react2.default.createElement('stop', { offset: '0%', stopColor: '#b620b4' }),
	        _react2.default.createElement('stop', { offset: '16%', stopColor: '#a227b6' }),
	        _react2.default.createElement('stop', { offset: '45%', stopColor: '#7437bc' }),
	        _react2.default.createElement('stop', { offset: '58%', stopColor: '#623fb1' }),
	        _react2.default.createElement('stop', { offset: '85%', stopColor: '#444e9f' }),
	        _react2.default.createElement('stop', { offset: '100%', stopColor: '#395398' })
	      )
	    );
	  };
	  return _react2.default.createElement(
	    'div',
	    { 'data-page': page, className: 'header' },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { className: 'header-link', to: '/' },
	      _react2.default.createElement(
	        'div',
	        { className: 'header-container' },
	        _react2.default.createElement(
	          'svg',
	          {
	            id: 'logo',
	            xmlns: 'http://www.w3.org/2000/svg',
	            viewBox: '0 0 191.19 196.23'
	          },
	          gradients(),
	          _react2.default.createElement(
	            'title',
	            null,
	            'logo'
	          ),
	          _react2.default.createElement('path', {
	            className: 't1',
	            fill: 'url(#t1)',
	            d: 'M123.33,26.09,39,44.73C7,51.81-5.33,90.86,16.8,115l58.31,63.71c22.12,24.17,62.11,15.33,72-15.91l26-82.35C183,49.23,155.32,19,123.33,26.09Z'
	          }),
	          _react2.default.createElement('path', {
	            className: 't2',
	            fill: 'url(#t2)',
	            d: 'M94.64,11.23,17.87,74.44c-29.12,24-21.37,70.5,14,83.73L125,193c35.33,13.23,71.73-16.75,65.53-54L174.13,41C167.93,3.78,123.76-12.76,94.64,11.23Z'
	          }),
	          _react2.default.createElement('path', {
	            className: 't3',
	            fill: 'url(#t3)',
	            d: 'M59.44,35.6,16.26,110.4c-16.38,28.37,4.1,63.84,36.86,63.84h86.37c32.77,0,53.24-35.47,36.86-63.84L133.16,35.6C116.78,7.23,75.82,7.23,59.44,35.6Z'
	          }),
	          _react2.default.createElement(
	            'circle',
	            { className: 'c', cx: '97.5', cy: '107.5', r: '35' },
	            _react2.default.createElement('animate', {
	              attributeType: 'XML',
	              attributeName: 'stroke-dashoffset',
	              from: '220',
	              to: '20',
	              dur: '2s',
	              repeatCount: '1'
	            })
	          ),
	          _react2.default.createElement(
	            'text',
	            { className: 'h', x: '100', y: '100', dx: '-20', dy: '25', rotate: '-5' },
	            'H'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'title-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'site-title' },
	            siteInfo.title
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'site-desc' },
	            siteInfo.description
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 458:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(137);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _header = __webpack_require__(217);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(216);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _categories = __webpack_require__(83);
	
	var _categories2 = _interopRequireDefault(_categories);
	
	__webpack_require__(310);
	
	__webpack_require__(462);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = function Layout(_ref) {
	  var children = _ref.children,
	      location = _ref.location,
	      data = _ref.data;
	
	  var pageName = location.pathname.split('/')[1] === '' ? 'home' : location.pathname.split('/')[1].split('.')[0];
	  var currentPage = 'p-' + pageName;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: data.site.siteMetadata.title,
	      meta: [{
	        name: 'description',
	        content: 'HCV Handbook is a comprehensive mini encyclopedia for all related informnation about Hepatitis C Virus; 丙型肝炎手册是一本关于 C 型肝炎病毒及其相关信息的迷你小百科'
	      }, {
	        name: 'keywords',
	        content: 'Hepatitis C Virus, HCV, Hepatitis, Hepatitis C, virus, inflammation, cirrhosis, transfusion, snort, hemodialysis, tattoo, fatigue, fever, early stages, acute, chronic, antibody, PCR, biopsy, ultrasound, MRI, antibody, Interferons, DAA, genotype, transplant, cancer, ascites, Pressure, Bleeding, Toxins, diet, never share needles, safe sex, hand hygiene, disease education, regular monitoring'
	      }]
	    }),
	    _react2.default.createElement(_header2.default, { page: currentPage, siteInfo: data.site.siteMetadata }),
	    _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      children()
	    ),
	    _react2.default.createElement(_categories2.default, { page: currentPage }),
	    _react2.default.createElement(_footer2.default, null)
	  );
	};
	
	Layout.propTypes = {
	  children: _propTypes2.default.func,
	  location: _propTypes2.default.object
	};
	
	exports.default = Layout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 310:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 462:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-c023b94dd3f3859b509c.js